var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"position-absolute top left mt-5 ml-2"},[_c('b-button',{attrs:{"variant":"light"},on:{"click":_vm.switchLoginMethod}},[_c('i',{staticClass:"fa-solid fa-chevron-left"}),_vm._v("\n        "+_vm._s(_vm.usingPassword ? '人脸登录' : '密码登录')+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }